export default __webpack_public_path__ + "static/media/covid.944e1fc6.png";